import axios from 'axios';

import type { BuildJsonType } from '@bb/domain/dist/typeHelpers';
import type { Covid19Settings } from '@bb/domain/dist/types';

export type SaveCovid19ListingSettingsResponse = BuildJsonType<Covid19Settings>;

const saveCovid19ListingSettings = async (
  settings: Covid19Settings,
  listingId: string,
) => {
  const { data: covid19Settings } =
    await axios.post<SaveCovid19ListingSettingsResponse>(
      `/covid19/listing/${listingId}/settings`,
      settings,
    );

  return covid19Settings;
};

export default saveCovid19ListingSettings;
